module.exports = __webpack_public_path__ + "static/media/kfc.06bb9c6b.jpg";